import ProjectSession from "../../../../../core/model2/project/project-session";
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const";
import {NavigationMenuInlineAddType} from "../@types";
import {EmbedType} from "../../../../../core/gd/const/embed/embed-type";
import {EmbedTypeConfigs} from "../../../../../core/gd/const/embed/embed-type-config";


export function menuAdd_initEmbedLink(options:Options, onAddInline : func, project?:ProjectSession) {


    const disableNewLink    = project ? !project.acl.canCreateLink      : false
    const disableNewEmbed   = project ? !project.acl.canCreateEmbed     : false


    const onAddEmbed = (embedType: EmbedType) => {
        onAddInline(NavigationMenuInlineAddType.EMBED, {embedType})
    }



    const getItem = (embedType: EmbedType) => {
        const embedTypeConfig: any = EmbedTypeConfigs[embedType]

        // debug && console.log(debug, 'process getItem', embedTypeConfig)

        return {
            label   : embedTypeConfig.name,
            icon    : embedTypeConfig.icon,
            onClick : ()=>{onAddEmbed(embedType)}
        }
    }

    // generate embed options
    const embedOptions = _.compact([

        {
            icon: 'i5-copy-link',
            label: 'Link',
            disabled: disableNewLink,
            onClick: ()=>{ onAddInline(NavigationMenuInlineAddType.LINK) }
        },

        getItem(EmbedType.DEFAULT),

        {type: PopoverMenuItemType.SEPARATOR},

        getItem(EmbedType.FIGMA),
        getItem(EmbedType.GOOGLE_MAP),
        getItem(EmbedType.YOUTUBE),
        getItem(EmbedType.GOOGLE_CALENDAR),
        getItem(EmbedType.GOOGLE_DOC),
        getItem(EmbedType.GOOGLE_SHEET),
        getItem(EmbedType.GOOGLE_SLIDES),
        getItem(EmbedType.FACEBOOK),
        getItem(EmbedType.TWITTER),

    ])




    // const embedOptions = menuAdd_getEmbedOptions(onAddEmbed)

    options.push({
        type        : PopoverMenuItemType.SUBMENU,
        // icon        : 'i5-embeded-code',
        // icon        : 'i5-copy-link',
        icon        : 'i5-embeded-code',
        label       : 'Embed',
        disabled    : disableNewEmbed,
        options     : [
            ...embedOptions
        ]
    })

    // options.push({
    //     icon: 'i5-copy-link',
    //     label: 'Link',
    //     disabled: disableNewLink,
    //     onClick: ()=>{ onAddInline(NavigationMenuInlineAddType.LINK) }
    // })


}
